import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Props from './AddTicketsComponent';
import { isKioskMode, isMultiEmbed } from '../../../selectors/ui';
import Translation from '@checkout-s/Translation';
import { onKeyboardClick } from '@checkout-b/helpers/accessability';
import { TranslationContext } from '@checkout-c/Translations';

class AddTickets extends Component<Props> {
    render() {
        return(
            <div className="ticket-quantity">
                {this.getContent()}
            </div>
        )
    }

    getContent = () => {
        const addItemStub = this.props.type ? `checkout__add_${this.props.type}` : 'checkout__add';
        const subtractItemStub = this.props.type ? `checkout__subtract_${this.props.type}` : 'checkout__subtract';

        const quantities = Array.isArray(this.props.quantities) && this.props.quantities.length ? this.props.quantities : [];
        let maxQuant = quantities[quantities.length -1];
        let soldOut = this.props.initialQuantities && this.props.initialQuantities.length === 0;
        let limitReached = quantities.length === 0;
        if (soldOut) {
            return <div className="ticket__price"><span><Translation>{'checkout__sold_out'}</Translation></span></div>;
        } else if(limitReached) {
            return <div className="ticket__price"><span><Translation>{'checkout__limit_reached'}</Translation></span></div>;
        } else {
            if (!this.props.showZeroQuantity && (this.props.quantity === undefined || this.props.quantity === 0)) {
                return (
                    <div className="ticket-action__add">
                        <TranslationContext.Consumer>
                            {({ t }) => (
                                <button
                                disabled={!!this.props.disabled}
                                className="button button--primary ticket-action__add-button"
                                onMouseDown={this.props.onIncrement}
                                onKeyDown={onKeyboardClick(this.props.onIncrement)}
                                aria-describedby={this.props.describedBy}
                                aria-label={t(addItemStub)}
                                >
                                    <Translation>{'checkout__add'}</Translation>
                                </button>
                            )}
                        </TranslationContext.Consumer>
                    </div>
                );
            } else {
                return (
                     <div className="ticket-action__quantity">
                        <button
                          disabled={!!this.props.disabled}
                          className="button button--default quantity__decrement"
                          onMouseDown={this.onDecrement}
                          onKeyDown={onKeyboardClick(this.onDecrement)}
                          aria-describedby={this.props.describedBy}
                        >
                          <i className="icon-remove" aria-hidden="true"></i>
                          <span className="sr-only"><Translation>{subtractItemStub}</Translation></span>
                        </button>
                        <TranslationContext.Consumer>
                          {({ t }) => (
                            <select
                              className="form-control quantity__input"
                              name="quantity_input"
                              onChange={this.props.onQuantityInput}
                              type="tel"
                              value={this.props.quantity === undefined ? 0 : this.props.quantity}
                              aria-label={t('checkout__select_quantity')}
                              aria-describedby={this.props.describedBy}
                            >
                                {this.props.showZeroQuantity && quantities.indexOf(0) === -1 && <option>0</option>}
                                {quantities.map((num, index) => {
                                    return <option key={index} value={num}>{num}</option>
                                })}
                            </select>
                          )}
                        </TranslationContext.Consumer>
                        <span className="quantity__input quantity__input--mask">{this.props.quantity === undefined ? 0 : this.props.quantity}</span>
                        <button
                          className="button button--primary quantity__increment"
                          disabled={this.props.quantity >= maxQuant || !!this.props.disabled}
                          onMouseDown={this.props.onIncrement}
                          onKeyDown={onKeyboardClick(this.props.onIncrement)}
                          autoFocus={!this.props.showZeroQuantity}
                          aria-describedby={this.props.describedBy}
                        >
                          <i className="icon-add" aria-hidden="true"></i>
                          <span className="sr-only"><Translation>{addItemStub}</Translation></span>
                        </button>
                    </div>
                );
            }
        }
    }

    onDecrement = () => {
        if (!isNaN(this.props.quantity) && this.props.quantity > 0) {
            this.props.onDecrement();
        }
    }
}

AddTickets.propTypes = {
    quantity: PropTypes.number,
    onIncrement: PropTypes.func.isRequired,
    onDecrement: PropTypes.func.isRequired,
    onQuantityInput: PropTypes.func.isRequired,
    quantities: PropTypes.arrayOf(PropTypes.number).isRequired,
    initialQuantities: PropTypes.arrayOf(PropTypes.number)
};

AddTickets.Type = {
    Tickets: 'ticket',
    Products: 'product',
    Bundles: 'bundle'
}

const mapStateToProps = (state, ownProps) => {
    return {
        showZeroQuantity: isKioskMode(state) || isMultiEmbed(state) || !!ownProps.showZeroQuantity,
    }
};

export default connect(mapStateToProps)(AddTickets)
